/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlock_Button_TextInputs */

const en_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock`)
};

const ar_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح`)
};

const de_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freischalten`)
};

const es_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear`)
};

const fr_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquer`)
};

const it_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca`)
};

const ja_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アンロック`)
};

const ko_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잠금 해제`)
};

const pt_br_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear`)
};

const ru_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокировать`)
};

const th_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อก`)
};

const tr_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilidi Aç`)
};

const zh_cn_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁`)
};

const zh_tw_unlock_button_text = /** @type {(inputs: Unlock_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解鎖`)
};

/**
* | output |
* | --- |
* | "Unlock" |
*
* @param {Unlock_Button_TextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const unlock_button_text = /** @type {((inputs?: Unlock_Button_TextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlock_Button_TextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlock_button_text(inputs)
	if (locale === "ar") return ar_unlock_button_text(inputs)
	if (locale === "de") return de_unlock_button_text(inputs)
	if (locale === "es") return es_unlock_button_text(inputs)
	if (locale === "fr") return fr_unlock_button_text(inputs)
	if (locale === "it") return it_unlock_button_text(inputs)
	if (locale === "ja") return ja_unlock_button_text(inputs)
	if (locale === "ko") return ko_unlock_button_text(inputs)
	if (locale === "pt_br") return pt_br_unlock_button_text(inputs)
	if (locale === "ru") return ru_unlock_button_text(inputs)
	if (locale === "th") return th_unlock_button_text(inputs)
	if (locale === "tr") return tr_unlock_button_text(inputs)
	if (locale === "zh_cn") return zh_cn_unlock_button_text(inputs)
	return zh_tw_unlock_button_text(inputs)
});